// extracted by mini-css-extract-plugin
export default {"root":"RouteView_root__KlvOk","boxCenter":"RouteView_boxCenter__ImQCG","activeRoute":"RouteView_activeRoute__eYYN-","text":"RouteView_text__COcSZ"};